module.exports = __webpack_public_path__ + "static/media/create-appointment-icon.4d3abcef.svg";